import config from '@packages/config';

const {
  assets: { assetServerHost },
} = config;

const imageFolder = `${assetServerHost}/i/empiriecom/`;

export const GARAN_NESTED_LABEL_IMAGE_PATH = `${imageFolder}GARAN_nestedLabel.svg`;
export const GARAN_LABEL_IMAGE_PATH = `${imageFolder}GARAN_label.svg`;
export const GARAN_HEADLINE = 'GARAN';
